<template>
  <div v-if="loading" class="mt-16 flex w-full justify-center">
    <InfuseSpinner size="large" />
  </div>

  <dl v-else class="flex flex-row py-6">
    <div class="flex grow flex-col">
      <InfuseDescriptionListItem
        v-for="(row, index) in filteredRows"
        :key="row.name"
        :row="row"
        :item="item"
        :color="index % 2 === 0 ? 'grey' : 'white'"
        :copyable="row.copyable"
        :is-generic-slot="useGenericSlots"
      >
        <template #name>
          <slot name="name" :data-name="row.name" :data-term="row.term"></slot>
        </template>
        <template v-if="useGenericSlots" #value>
          <slot name="value" :data="get(item, row.detailField)"></slot>
        </template>
        <template v-else #[row.name]>
          <slot :name="row.name" :data="get(item, row.detailField)"></slot>
        </template>
      </InfuseDescriptionListItem>
    </div>

    <div v-if="!!$slots.extras" class="basis-1/4">
      <slot name="extras"></slot>
    </div>
  </dl>
</template>

<script lang="ts" setup>
import { UiDescriptionListRow } from '@infuse/ui/domain';
import { getFieldFromPath } from '@infuse/utils';
import { computed } from 'vue';
import { InfuseDescriptionListItem, InfuseSpinner } from '../index';

interface Props {
  item: any;
  rows: UiDescriptionListRow[];
  useGenericSlots?: boolean;
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  rows: () => [],
  useGenericSlots: false,
  loading: false
});

const filteredRows = computed(() => props.rows.filter((r) => !r.hidden));

// TODO don't use `any`
//@eslint-disable-next-line @typescript-eslint/no-explicit-any
const get = (obj: unknown, path: any, defValue?: unknown) => getFieldFromPath(obj, path, defValue);
</script>
